import { SequentialFetchQueue } from './sequential-fetch-queue';
import * as fetch from 'cross-fetch';
var fetchTimeout = 20000;
var queueTimeout = 120000;
export function internalFetch(url, options, callback) {
    var request = new fetch.Request(url, options);
    return fetchQueue.add(request, callback);
}
/**
 * NOTE: The cross-fetch type declarations suggest that either of these import statements should work, but they don't:
 * import { fetch } from 'cross-fetch';
 * import fetch from 'cross-fetch';
 */
var fetchQueue = new SequentialFetchQueue(fetch, fetchTimeout, queueTimeout);
//# sourceMappingURL=fetch.js.map